var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyerBenefits2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.71 53.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,30.21a1,1,0,0,1-1-1V13C9,5.83,14.38,0,21,0h1.78c6.64,0,12,5.83,12,13v.81a1,1,0,1,1-2,0V13c0-6.07-4.5-11-10-11H21C15.49,2,11,6.93,11,13V29.21A1,1,0,0,1,10,30.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,23.24H2.73A2.24,2.24,0,0,0,.5,25.47V50.8A2.24,2.24,0,0,0,2.73,53H39a2.25,2.25,0,0,0,2.24-2.24V25.47A2.25,2.25,0,0,0,39,23.24Zm-16.8,14v9.86H19.53V37.2a4.1,4.1,0,1,1,2.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,22.74H2.73A2.73,2.73,0,0,0,0,25.47V50.8a2.74,2.74,0,0,0,2.73,2.74H39a2.74,2.74,0,0,0,2.73-2.74V25.47A2.74,2.74,0,0,0,39,22.74ZM40.71,50.8A1.74,1.74,0,0,1,39,52.54H2.73A1.73,1.73,0,0,1,1,50.8V25.47a1.73,1.73,0,0,1,1.73-1.73H39a1.74,1.74,0,0,1,1.73,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,33.31a4.1,4.1,0,0,1-2.78,3.89v9.86H19.53V37.2A4.1,4.1,0,1,1,25,33.31Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerBenefits2);
export default __webpack_public_path__ + "static/media/buyer_benefits_2.dc3277686e1688ba8ad440d7dbe62fc1.svg";
export { ForwardRef as ReactComponent };